import React from "react";
import ProfileTitle from "../../../../components/ProfileTitle";
import * as api from '../../../../apis/platforms/admin/baseData'
import useAntTable from "../../../../utils/useAntTable";
import StandardTable, {StandardColumnsType} from "../../../../components/StandardTable";
import {Button, Divider, Popconfirm, Space} from "antd";
import useFormModal from "../../../../utils/useFormModal";
import GroupEditModal from "./groupEditModal";
import {useRequest} from "ahooks";

export default function Group() {

    const {tableProps, refresh} = useAntTable(api.getGroups, {})

    const {setVisible, modalProps} = useFormModal({
        onRequest: api.editGroup,
        onOk: () => {
            setVisible(false)
            refresh()
        }
    })

    const {run: onDelete} = useRequest(api.deleteGroup, {
        manual: true,
        onSuccess: () => {
            refresh()
        }
    })

    const columns: StandardColumnsType = [
        {
            title: '集团',
            dataIndex: 'group'
        },
        {
            title: '描述',
            dataIndex: 'desc'
        },
        {
            title: '销售人员',
            dataIndex: 'saleManName'
        },
        {
            title: '操作',
            dataIndex: 'operations',
            render: (_, record: any) => (
                <Space split={<Divider type="vertical" />}>
                    <a onClick={() => {
                        setVisible(true, record)
                    }}>编辑</a>
                    <Popconfirm title={'是否确认删除'} onConfirm={() => onDelete(record.id)}>
                        <a>删除</a>
                    </Popconfirm>
                </Space>
            )
        }
    ]

    return (
        <div>
            <ProfileTitle>集团</ProfileTitle>
            <StandardTable {...tableProps} columns={columns} showCard={false} rowKey={'id'} toolbar={
                <Button type={'primary'} onClick={() => setVisible(true)}>新增</Button>
            }/>
            <GroupEditModal {...modalProps}/>
        </div>
    )
}
